import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import IndexedDBClassificationRepository from "../Classifications/IndexedDBClassificationRepository";

export default class IndexedDBCategoryRepository extends IndexedDBClassificationRepository {
    public readonly source: InternalIndexedDBDatabase["categories"];
    protected readonly dataTypeName = "Category";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.categories;
    }
}
